module.exports = __webpack_public_path__ + "static/reel-sun-2-2b961ab0ac3d441ff983d1156b3a4318.mp4";